import React, { useState, useEffect } from 'react';
import styles from './index.module.scss'
import More from '../../static/images_ae/moreArrow.png';
import tool_top_banner from '../../static/images_ae/alkReport/tool_top_banner.png';
import tool_purple_pencil from '../../static/images_ae/alkReport/tool-purple-pencil.png';
import tool_purple_all from '../../static/images_ae/alkReport/tool-purple-all.png';
import icon_plus from '../../static/images/icon-plus.png';
import icon_search from '../../static/images_doctor/tool_introdce_search.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';
import AlkCommonAskDetail from '../AlkCommonAskDetail/index';
import rightArrow from '../../static/images_ae/alkAsk/rightArrow.png';
import no_result from '../../static/images_ae/alkAsk/no_result.png';
import adverseReactions from '../../static/images_ae/alkAsk/adverseReactions.png';
import dietaryProblems from '../../static/images_ae/alkAsk/dietaryProblems.png';
import lungCancerKnowledge from '../../static/images_ae/alkAsk/lungCancerKnowledge.png';
import medicineKnowledge from '../../static/images_ae/alkAsk/medicineKnowledge.png';
import medicationGuidance from '../../static/images_ae/alkAsk/medicationGuidance.png';
import nursingProblems from '../../static/images_ae/alkAsk/nursingProblems.png';
import serviceProblems from '../../static/images_ae/alkAsk/serviceProblems.png';
import useQuestions from '../../static/images_ae/alkAsk/useQuestions.png';
import icon_more from '../../static/images_ae/alkTest/more.png';
import icon_more_arrow from '../../static/images_ae/personal/icon_more_arrow.png';
import r_arrow_blue from '../../static/images_ae/alkTest/r_arrow_blue.png';
import { Toast, Popup } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import { ApiCore } from '../../api/index';

const api = new ApiCore();

const commonNav = [{
    text: '疾病问题'
}, {
    text: '用药问题'
}, {
    text: '生活问题'
}, {
    text: '平台问题'
}]

const AlkCommonAsk = (props: any) => {

    const [isCommonTag, setIsCommonTag] = useState<any>(true)

    const [alkTagList, setAlkTagList] = useState<any>([])

    const [questionnaireList, setQuestionnaireList] = useState([])

    const [visible, setVisible] = useState(false)
    //搜索关键字
    const [searchKey, setSearchKey] = useState<any>('');
    // 
    const [activeIndex, setActiveIndex] = useState(-1);

    const [firstCategorys,setFirstCategorys] = useState<any>([]);
    const [positionSymptoms, setPositionSymptoms] = useState<any>([]);
    const [secondCategorys, setSecondCategorys] = useState<any>([]);

    const [commonTagList, setCommonTagList] = useState<any>([])
    const [tagList, setTagList] = useState<any>([])

    const [list, setList] = useState<any>([]);
    const [listMap, setListMap] = useState<any>({});
    const [listReady, setListReady] = useState(false);

    const [activeSymptomCode, setActiveSymptomCode] = useState<any>('');
    const [articleId, setArticleId] = useState<any>('');
    const [showNowPage, setShowNowPage] = useState<any>(true);

    const [dialogHasSelected, setDialogHasSelected] = useState(false)

    useEffect(() => {
        window.document.title = '常见问答';
        initData();
    }, [])

    useEffect(() => {
        const _item = commonTagList.filter((item: any) => ((item.isMore && item.active) || (item.bothHas && item.active)));
        setDialogHasSelected((_item && _item.length > 0));
        setTimeout(() => {
            const _scrollEl = document.getElementById('edc_wechat_alk_common_ask_nav');
            _scrollEl && _scrollEl.scrollIntoView({behavior: "smooth", block: "end", inline: "start"});
        }, 500)
    }, [commonTagList])

    // 初始化数据
    const initData = () => {
        api.getQuestionConfig().then((res: any) => {
            if (res.code == 0) {
                const _data: any = res.data || {};
                setFirstCategorys(_data.firstCategorys);
                setPositionSymptoms(_data.positionSymptoms);
                // const _commonTagList = _data.positionSymptoms.filter((val: any) => val.isTop);
                // setCommonTagList(_commonTagList);
                // setTagList(_data.positionSymptoms);
                setSecondCategorys(_data.secondCategorys);

                // 部位、症状分组
                const __data = res.data?.positionSymptoms;
                const _commonTagList:any = [];
                const _list = [];
                const _listMap = {};
                let _count = -1;
                __data.forEach((v: any) => {
                    if (!_listMap[v.positionCode]) {
                        _count++;
                        v.index = _count;
                        _listMap[v.positionCode] = [v];
                    } else if (_listMap[v.positionCode]) {
                        v.index = _count;
                        _listMap[v.positionCode] = [..._listMap[v.positionCode], v]
                    }
                    if (v.isTop) {
                        _commonTagList.push(v);
                    }
                });
                for (const _key in _listMap) {
                    if (Object.prototype.hasOwnProperty.call(_listMap, _key)) {
                        const _element = _listMap[_key];
                        _list[_element[0].index] = _element;
                    }
                }
                setCommonTagList(_commonTagList);
                setTagList(_list);

                const item = {
                    firstCategory: _data.firstCategorys[0].code,
                    symptomCode: '',
                    title: ''
                };
                api.getQuestionList(item).then((res: any) => {
                    if (res.code == 0) {
                        const secondCategorysMap = {}
                        _data.secondCategorys.forEach((v: any) => {
                            secondCategorysMap[v.code] = v;
                        });
                        const data = res.data;
                        const _dataMap = {};
                        data.forEach((v: any) => {
                            const _item = secondCategorysMap[v.secondCategory];
                            if (_item) {
                                if (_dataMap[v.secondCategory]) {
                                    _dataMap[v.secondCategory] = [..._dataMap[v.secondCategory], {...v, ..._item}];
                                } else {
                                    _dataMap[v.secondCategory] = [{...v, ..._item}];
                                }
                            }
                        });
                        setActiveIndex(0);
                        setListMap(_dataMap);
                        setListReady(true);
                    }
                })
            }
        })

    }

    // 重置标签
    const setOrginCommonTags = () => {
        let _commonTagList: any = JSON.parse(JSON.stringify(commonTagList));
        _commonTagList = _commonTagList.map((v: any) => { return {
            ...v, active: false
        }})
        setCommonTagList(_commonTagList);
    }

    // 点击症状筛选
    const clickItem = (v: any) => {
        let _list =JSON.parse(JSON.stringify(commonTagList));
        let hasBefore = false;
        _list = _list.map((val: any) => {
            if (v.code == val.code) {
                hasBefore = true;
                return {
                    ...val,
                    active: true,
                    bothHas: true
                }
            } else {
                return {
                    ...val,
                    active: false
                }
            }
        })
        if (!hasBefore) {
            _list = _list.filter((v: any) => !v.isMore)
            // 从弹框里选中来的
            _list.unshift({ ...v, active: true, isMore: true })
        }
        setCommonTagList(_list);
        setVisible(false);
        setActiveSymptomCode(v.code);
        let _firstCategory = firstCategorys[0].code;
        const noCondition = (!v.code && !searchKey);
        onListSearch({
            firstCategory: noCondition ? _firstCategory : '', 
            symptomCode: v.code,
            title: searchKey || ''
        }, noCondition ? 0 : -1) ;
    }

    const tagsActive = (v: any, index: number) => {
        const _commonTagList: any = JSON.parse(JSON.stringify(commonTagList));
        let _activeCode: any = '';
        let _list = _commonTagList.map((val: any, key: number) => {
            if (key == index) {
                const _active = !val.active;
                if (_active) {
                    _activeCode = val.code;
                    setActiveSymptomCode(val.code);
                } else {
                    _activeCode = '';
                    setActiveSymptomCode('');
                }
                return {
                    ...val,
                    active: _active
                }
            }  else {
                return {
                    ...val,
                    active: false
                }
            }
        })
        // _list = _list.filter((v: any) => !v.isMore);
        setCommonTagList(_list);
        let _firstCategory = firstCategorys[0].code;
        const noCondition = (!_activeCode && !searchKey);
        onListSearch({
            firstCategory: noCondition ? _firstCategory : '', 
            symptomCode: _activeCode,
            title: searchKey, 
        }, noCondition ? 0 : -1);
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchKey(event.target.value);
        if (event.target.value) {
            onListSearch({ 
                firstCategory: '', 
                symptomCode: activeSymptomCode,
                title: event.target.value
            }, -1);
        } else {
            onListSearch({
                firstCategory: firstCategorys[0].code, 
                symptomCode: activeSymptomCode,
                title: '', 
            }, 0) 
        }
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchKey('');
        onListSearch({
            firstCategory: firstCategorys[0].code, 
            symptomCode: activeSymptomCode,
            title: '', 
        }, 0) 
    }

    const toNavIndex = (v: any, index: number) => {
        const item = {
            firstCategory: v.code,
            symptomCode: activeSymptomCode,
            title: ''
        };
        api.getQuestionList(item).then((res: any) => {
            if (res.code == 0) {
                const secondCategorysMap = {}
                secondCategorys.forEach((v: any) => {
                    secondCategorysMap[v.code] = v;
                });
                const data = res.data;
                const _dataMap = {};
                data.forEach((v: any) => {
                    const _item = secondCategorysMap[v.secondCategory];
                    if (_item) {
                        if (_dataMap[v.secondCategory]) {
                            _dataMap[v.secondCategory] = [..._dataMap[v.secondCategory], {...v, ..._item}];
                        } else {
                            _dataMap[v.secondCategory] = [{...v, ..._item}];
                        }
                    }
                });
                setActiveIndex(index);
                setListMap(_dataMap);
                setListReady(true);
            }
        })
    }

    // 根据搜索条件展示数据
    const onListSearch = (mParam: {
        firstCategory: '', 
        symptomCode: '',
        title: '', 
    }, index: number) => {
        const item = {
            firstCategory: mParam.firstCategory,
            symptomCode: mParam.symptomCode,
            title: mParam.title
        };
        api.getQuestionList(item).then((res: any) => {
            if (res.code == 0) {
                const secondCategorysMap = {}
                secondCategorys.forEach((v: any) => {
                    secondCategorysMap[v.code] = v;
                });
                const data = res.data;
                const _dataMap = {};
                data.forEach((v: any) => {
                    const _item = secondCategorysMap[v.secondCategory];
                    if (v.title) {
                        v.title = v.title.replace(mParam.title, `<span style="color:#0222bb;font-weight:bold;">${mParam.title}</span>`);
                    }
                    if (_item) {
                        if (_dataMap[v.secondCategory]) {
                            _dataMap[v.secondCategory] = [..._dataMap[v.secondCategory], {...v, ..._item}];
                        } else {
                            _dataMap[v.secondCategory] = [{...v, ..._item}];
                        }
                    }
                });
                setActiveIndex(index);
                setListMap(_dataMap);
                setListReady(true);
            }
        })
    }
    
    const toNextPage = (val: any) => {
        // props.history.push(`/alk/commonAsk/detail?id=${val.id}`);
        setArticleId(val.id);
        setShowNowPage(false);
    }

    const onBefore = () => {
        setShowNowPage(true);
    }

    const titleImg = (value: any) => {
        let icon = '';
        const val = value[0];
        if (val.name == '肺癌知识') {
            icon = lungCancerKnowledge;
        } else if (val.name == '不良反应') {
            icon = adverseReactions;
        } else if (val.name == '用药知识') {
            icon = medicineKnowledge;
        } else if (val.name == '用药指导') {
            icon = medicationGuidance;
        } else if (val.name == '护理问题') {
            icon = nursingProblems;
        } else if (val.name == '饮食问题') {
            icon = dietaryProblems;
        } else if (val.name == '服务问题') {
            icon = serviceProblems;
        } else if (val.name == '使用问题') {
            icon = useQuestions;
        }
        return icon;
    }

    return (
        <div className={styles.common_ask_container}>
            {
                showNowPage ?
            <>
                <div className={styles.header}>
                    <div className={styles.search}>
                        <div className={`${styles.tool_introduce_head}`}>
                            <div className={styles.search_head}>
                                <div className={styles.search}>
                                    <img className={styles.search_img} src={icon_search} alt="" />
                                    <input type="text" placeholder="请在此处输入你要搜索的问题" value={searchKey} onChange={(event) => { titleInput(event) }} />
                                    {
                                        searchKey &&
                                        <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={ () => { clearInput() }} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.middle_nav_wrap}>
                        <div className={styles.middle_nav}>
                        {
                            (commonTagList|| []).map((v: any, k: number) => (
                                <div key={k} className={v.active ? styles.active : ''} id={v.active ? 'edc_wechat_alk_common_ask_nav' : ''} onClick={() => { tagsActive(v, k) }}>
                                    {v.name}{v.countNum}
                                </div>
                            ))
                        }
                        </div>
                        <div className={styles.icon_right}
                            onClick={() => {
                                setVisible(true)
                            }}
                        >
                            <div>
                                {
                                    !dialogHasSelected ?
                                    <>
                                    <div>全部</div>
                                        <div>症状</div>
                                    </>
                                    :
                                    <>
                                    <div>已经</div>
                                        <div>筛选</div>
                                    </>
                                }
                            </div>
                            <img src={icon_more_arrow} alt="" />
                        </div>
                        {/* <div className={styles.top_nav_other}
                                onClick={() => {
                                    setVisible(true)
                                }}
                        >
                                <span>更多</span>
                                <div className={styles.triangle}></div>
                        </div> */}
                    </div>
                </div>
                <div className={`${(Object.values(listMap).length > 0 && activeIndex > 0) ? `${styles.body_content} ${styles.body_content_border}` : `${styles.body_content}`}`}>
                    {
                        activeIndex >= 0 && 
                        <div className={styles.top_nav}>
                            {
                                firstCategorys && firstCategorys.map((v: any, k: number) => (
                                    <div className={`${styles.top_nav_item} ${activeIndex == k ? styles.active_nav : ''}`} onClick={ () => { toNavIndex(v, k) }}>
                                    {v.name}
                                    {
                                        activeIndex == k &&
                                        <div className={styles.border}></div>
                                    }
                                </div>
                                ))
                            }
                        </div>
                    }
                    {
                        listReady && (Object.values(listMap).length === 0) &&
                        <div className={styles.no_result}>
                            <img src={no_result} alt="" />
                        </div>
                    }
                    {
                        Object.values(listMap).length > 0 &&
                        <div className={styles.article_list}>
                        {
                            Object.values(listMap).map((val: any, key: number) => (
                            <div key={key} className={styles.article_list_item} >
                                <div className={styles.item_left}>
                                    <img src={titleImg(val)} alt="" />
                                    <div>
                                        <span>{val[0].name}</span>
                                        <img src={rightArrow} alt="" />
                                    </div>
                                </div>
                                <div className={styles.item_right}>
                                    {
                                        val.map((v: any, k: number) => (
                                            <div key={k} onClick={() => { toNextPage(v) }} dangerouslySetInnerHTML={{__html: v.title}}>
                                                {/* {v.title} */}
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            )
                            )
                        }
                        <div className={styles.no_more_bottom}>暂无更多</div>
                        </div>
                    }

                </div>
                <Popup
                    visible={visible}
                    position='top'
                    onMaskClick={() => {
                        setVisible(false)
                    }}
                    bodyStyle={{ height: '80vh', overflow: 'auto', borderBottomLeftRadius: '15px', borderBottomRightRadius: '15px' }}
                >
                    <div className={styles.position_wrap}>
                        {/* <div className={styles.position}>
                            <div className={styles.organ_item_wrap}>
                                    {
                                        (positionSymptoms || []).map((v: any, k: number) => (
                                            <div className={`${styles.organ_item} `} key={k}
                                                onClick={() => { clickItem(v) }}
                                            >
                                                {v.name}{v.countNum ? `(${v.countNum})` : null}
                                            </div>
                                        ))
                                    }
                            </div>
                        </div> */}

                    {
                        (tagList || []).map((val: any, index: number) => (
                            <div className={styles.position} key={index}>
                                <div className={styles.position_name}>{val[0].positionName}</div>
                                <div className={styles.organ_item_wrap}>
                                {
                                    (val || []).map((v: any, k: number) => (
                                        <div className={`${styles.organ_item} ${v.countNum ? '' : styles.un_active}`} key={k}
                                            onClick={() => { clickItem(v) }}
                                        >
                                            {v.name}{v.countNum ? `(${v.countNum})` : null}
                                        </div>
                                    ))
                                }
                                </div>
                            </div>
                        ))
                    }
                    </div>
                </Popup>
            </>
            :
            <AlkCommonAskDetail onBefore={onBefore} articleId={articleId} />
            }
        </div>
    )
}

export default withRouter(AlkCommonAsk);